// The v2 configuration with password sign-in off: the pilot stores use the v2 hosts
// while every other store stays on mtm.isaia.it (v1).
import { createEnvironment } from './environment.model';
import { ORIGIN_V2_API, ORIGIN_V2_APP } from './_origin';

export const environment = createEnvironment({
  production: true,
  name: 'pilot',
  encryptionStorage: 'aes',
  sentry: {
    sampleRate: 1.0,
  },
  origin: {
    app: ORIGIN_V2_APP,
    api: ORIGIN_V2_API,
  },
  msal: {
    clientId: 'a2190b6a-fcef-46cb-a5ed-f944c3e4e163',
    authority: 'https://login.microsoftonline.com/17b90855-d3b5-42a2-82de-8bdc8d93224d',
    redirectUri: `${ORIGIN_V2_APP}/auth/login`,
  },
  // Madison/Rome pilot (Nov 2026): the v2 hosts, but on production data, so Microsoft
  // sign-in only. Stated rather than left to the default, as in production.
  devLogin: false,
});
